import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Deals from "@/pages/Deals";
import Contacts from "@/pages/Contacts";
import Companies from "@/pages/Companies";
import Agents from "@/pages/Agents";
import Inbox from "@/pages/Inbox";
import Forms from "@/pages/Forms";
import Discover from "@/pages/Discover";
import Deliverability from "@/pages/Deliverability";
import ProposalPublic from "@/pages/ProposalPublic";
import { PaymentResult } from "@/components/outreach/Payments";
import Analytics from "@/pages/Analytics";
import Settings from "@/pages/Settings";
import Tasks from "@/pages/Tasks";
import SignDocument from "@/pages/SignDocument";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Loading...</div>;
  if (user) return <Navigate to="/deals" replace />;
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
              <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
              <Route path="/payment/success" element={<PaymentResult success />} />
              <Route path="/payment/cancel" element={<PaymentResult success={false} />} />
              <Route path="/p/:token" element={<ProposalPublic />} />
              <Route path="/sign/:token" element={<SignDocument />} />
              <Route path="/" element={<Navigate to="/deals" replace />} />
              <Route path="/deals" element={<Protected><Deals /></Protected>} />
              <Route path="/contacts" element={<Protected><Contacts /></Protected>} />
              <Route path="/companies" element={<Protected><Companies /></Protected>} />
              <Route path="/agents" element={<Protected><Agents /></Protected>} />
              <Route path="/inbox" element={<Protected><Inbox /></Protected>} />
              <Route path="/forms" element={<Protected><Forms /></Protected>} />
              <Route path="/discover" element={<Protected><Discover /></Protected>} />
              <Route path="/deliverability" element={<Protected><Deliverability /></Protected>} />
              <Route path="/analytics" element={<Protected><Analytics /></Protected>} />
              <Route path="/settings" element={<Protected><Settings /></Protected>} />
              <Route path="/tasks" element={<Protected><Tasks /></Protected>} />
              <Route path="*" element={<Navigate to="/deals" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" richColors closeButton toastOptions={{ className: "shadow-[var(--shadow-lift)]" }} />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}
